import React from "react";
import { Route, Redirect } from "react-router-dom";
import {route} from '../Utils/constants.js';

export const ProtectedRouteAdmin = ({
  component: Component,granted,isAdmin,
  ...rest
}) => granted && isAdmin? (
  <Route
      {...rest}
      render={props => {
          return( <Component {...props} />);
      }}
    />
) : (
  <Redirect
    to={{
      pathname: route.PATH
      // state: { from: location }
    }}
  />
) 


